import { Outlet } from 'react-router-dom';
import { Header } from './header';
import { Footer } from './footer';
import { SkipLink } from './skip-link';

export function MarketingLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-bg text-fg">
      <SkipLink />
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1 outline-none">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
